import { ApiResponse } from "../type";

export async function getNullApiResponse() {
    return new Promise<ApiResponse<null>>((res) => res({ data: null, meta: null }));
}
